import { useState } from "react";
import usePageTitle from "../hooks/usePageTitle";
import { FaLink, FaAmazon, FaGoodreadsG, FaRegFilePdf } from 'react-icons/fa';
import StandardLink from "../tools/StandardLink";
import { BookList } from "../data/bookList";
import { CertificateList } from "../data/certificateList";

function AI() {
  usePageTitle('Continued Learning | Dochano');

  const [hoveredArticle, setHoveredArticle] = useState(0);

  return (
    <section id="Learning">
      <div id="Intro">
          <h1>Continued Learning</h1>
      </div>
      <p>Expanding my knowledge in AI and Management through books, articles, and websites.</p>

      <span className="heading-3a">Past Reads</span>
      <div className="bookList">
        <div className="carousel">      
          {
              BookList.map((book, index) => (
                <button onClick={() => setHoveredArticle(index)} className={ hoveredArticle === index ? 'selectedBook' : 'book' }><img src={book.image} alt={`Book | ${book.title}`} width="85" height="125" /></button>
              ))
          }
        </div>
      </div>

      <div className="displayCase"> 
        {
          BookList.map((book, index) => (
            <article key={book.title} style={{ display: hoveredArticle === index ? 'flex' : 'none' }}>
              <figure>
                <img src={book.image} alt={`Book | ${book.title}`} width="139" height="186" />
                <figcaption>Fig.{index + 1} - {book.title}</figcaption>
              </figure>
              <div>
                <header>
                  <cite>{book.title}</cite> by {book.author}
                </header>
                <p><strong>Brief Description:</strong> {book.description}</p>
                <p><strong>Personal Opinion:</strong> {book.opinion}</p>
                <p className="bookLinks">
                  { (book.link) && <StandardLink href={book.link}><FaLink title="Website" /></StandardLink> }
                  { (book.amazonLink) && <StandardLink href={book.amazonLink}><FaAmazon title="Amazon" /></StandardLink> }
                  { (book.goodreadsLink) && <StandardLink href={book.goodreadsLink}><FaGoodreadsG title="GoodReads" /></StandardLink> }
                  { (book.pdf) && <StandardLink href={book.pdf}><FaRegFilePdf title="PDF" /></StandardLink> }
                </p>
              </div>
            </article>
          ))
        }
        
      </div>

      <div id="certificates">
        <span className="heading-3a">Certificates</span>
        <div className="carousel-cert">      
          {
              CertificateList.map((certificate, index) => (
                <StandardLink key={certificate.title} href={certificate.link || certificate.image} target="_blank" rel="noopener noreferrer">
                  <figure>
                    <img src={certificate.image} width="250" height="200" alt={`Certificate | ${certificate.title}`} />
                    <figcaption>Fig.{index + 1} - {certificate.title}</figcaption>
                  </figure>
                </StandardLink>
              ))
          }
        </div>
      </div>
    </section>
  );
}

export default AI;